import { Reveal } from "@/components/Reveal";

export function PageHeader({ overline, title, intro, image }) {
  return (
    <section className="relative pt-32 sm:pt-40 pb-16 sm:pb-24 bg-ink text-ivory overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-ink/50" />
        </div>
      )}
      <div className="relative max-w-[1500px] mx-auto px-5 sm:px-8">
        {overline && <Reveal><p className="overline text-gold mb-6">{overline}</p></Reveal>}
        <Reveal delay={0.05}>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1] max-w-4xl">{title}</h1>
        </Reveal>
        {intro && <Reveal delay={0.1}><p className="mt-8 max-w-2xl text-ivory/70 leading-relaxed text-base sm:text-lg">{intro}</p></Reveal>}
      </div>
    </section>
  );
}
